import { HTMLInputTypeAttribute } from "react";
import {
  Controller,
  Control,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";
import { NumericFormat } from "react-number-format";

interface InputTextProps<FieldsType extends FieldValues> {
  type?: HTMLInputTypeAttribute;
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  rules?: RegisterOptions<FieldsType>;
  label?: string;
  required?: boolean;
  shouldUnregister?: boolean;
  disabled?: boolean;
  placeholder?: string;
  wrapperClassName?: string;
  requiredMessage?: string;
}

export default function PriceInput<FieldsType extends FieldValues>({
  placeholder,
  type,
  label,
  name,
  control,
  required,
  shouldUnregister,
  requiredMessage,
  rules,
  disabled,
  wrapperClassName = "",
}: InputTextProps<FieldsType>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: requiredMessage || (required && "Required"),
        ...(rules || {}),
      }}
      shouldUnregister={shouldUnregister}
      render={({ field, fieldState: { error } }) => {
        return (
          <div className={`relative ${wrapperClassName}`}>
            {label && (
              <label className={`inline-block text-gray-500 pb-1 text-sm`}>
                {label}
                {(required || requiredMessage) && (
                  <span className="text-red-600 ml-0.5 text-base">*</span>
                )}
              </label>
            )}
            <NumericFormat
              id={field.name}
              getInputRef={field.ref}
              name={field.name}
              defaultValue={field.value}
              prefix="$ "
              thousandSeparator
              placeholder={placeholder || "$ 0.00"}
              className={`w-full appearance-none border border-gray-300 px-3 py-2.5 rounded-lg disabled:bg-gray-50 disabled:border-gray-200 text-gray-900 placeholder-gray-500 invalid:border-1 invalid:border-red-500 focus:outline-none focus:shadow-none focus:ring-0 focus:border-gray-900 text-sm bg-gray-50`}
              disabled={disabled}
              onValueChange={({ value }) => field.onChange(value)}
              valueIsNumericString={false}
            />
            <p className="text-red-600 font-normal text-sm m-0 p-0 ml-1  bottom-0 left-0 right-0">
              {error?.message}
            </p>
          </div>
        );
      }}
    />
  );
}
